export default __webpack_public_path__ + "static/media/prettier.7109cf6b.svg";